/* eslint-disable react/require-default-props */
import { forwardRef, ReactNode, useImperativeHandle } from 'react';

import useDismissableDialog from '@/hooks/util/useDismissableDialog';

interface DialogBox2Properties {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  styles?: string;
  showCloseIcon: boolean;
  dismissable?: boolean;
}
export interface DialogBox2Reference {
  onDismiss: () => void;
}

const DialogBox2 = forwardRef<DialogBox2Reference, DialogBox2Properties>(
  (
    {
      open,
      onClose = () => {},
      children,
      styles = '',
      showCloseIcon,
      dismissable,
    }: DialogBox2Properties,
    reference,
  ) => {
    const { dialogReference, onDismiss } = useDismissableDialog({
      isOpen: open,
      onClose,
      dismissable,
    });
    useImperativeHandle(reference, () => ({
      onDismiss,
    }));
    return (
      <div className="absolute top-0 z-modal flex h-[100vh] w-[100vw] items-center backdrop-blur-sm backdrop-brightness-50">
        <dialog
          ref={dialogReference}
          open={open}
          className={`relative flex max-w-[733px] flex-col items-center justify-center rounded-xl bg-neutral-white px-[2em] py-8 ${styles}`}
        >
          {children}
          {showCloseIcon && (
            <button
              onClick={onDismiss}
              type="button"
              className="absolute right-[16px] top-[24px] z-modal flex h-[52px] w-[52px] items-center justify-center rounded-full bg-white"
            >
              <img src="./icons/cross-icon-grey.svg" className="h-[20px] w-[20px]" alt="Close" />
            </button>
          )}
        </dialog>
      </div>
    );
  },
);

DialogBox2.defaultProps = {
  onClose: () => {},
  styles: '',
};

export default DialogBox2;
